import { useId } from "react";

import { cn } from "@/lib/utils";

export function ButtonIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-7.5 w-55", className)}
      fill="none"
      viewBox="0 0 220 30"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 0H649V649H0z"
        fill={`url(#${id}b)`}
        transform="translate(-227 -229)"
      />
      <path
        d="M308.314-155.438a45.343 45.343 0 0132.613 31.497l79.297 276.543a45.336 45.336 0 01-10.967 43.991L209.412 403.538a45.34 45.34 0 01-43.583 12.498l-279.142-69.598a45.343 45.343 0 01-32.613-31.497l-79.297-276.543a45.336 45.336 0 0110.967-43.991l199.845-206.945a45.343 45.343 0 0143.583-12.498l279.142 69.598z"
        opacity="0.05"
        stroke={`url(#${id}c)`}
        strokeOpacity="0.8"
        strokeWidth="5"
      />
      <path
        d="M290.249-150.909a43.282 43.282 0 0132.161 28.961l84.859 261.17a43.275 43.275 0 01-8.997 42.332l-183.75 204.075a43.283 43.283 0 01-41.161 13.375l-268.61-57.095a43.279 43.279 0 01-32.16-28.961l-84.86-261.17a43.276 43.276 0 018.997-42.332l183.75-204.075a43.281 43.281 0 0141.161-13.375l268.61 57.095z"
        opacity="0.1"
        stroke={`url(#${id}d)`}
        strokeOpacity="0.8"
        strokeWidth="5"
      />
      <path
        d="M272.769-145.438a41.218 41.218 0 0131.573 26.495l89.45 245.762a41.215 41.215 0 01-7.157 40.59L218.524 367.756a41.221 41.221 0 01-38.732 14.098l-257.56-45.416a41.216 41.216 0 01-31.573-26.495l-89.451-245.762a41.215 41.215 0 017.157-40.59l168.11-200.347a41.22 41.22 0 0138.733-14.097l257.561 45.415z"
        opacity="0.14"
        stroke={`url(#${id}e)`}
        strokeOpacity="0.8"
        strokeWidth="5"
      />
      <path
        d="M255.916-139.063a39.158 39.158 0 0130.854 24.109l93.074 230.366a39.154 39.154 0 01-5.449 38.774L221.43 349.973a39.162 39.162 0 01-36.306 14.669l-246.04-34.579a39.157 39.157 0 01-30.854-24.108l-93.074-230.366a39.155 39.155 0 015.449-38.775l152.966-195.787a39.16 39.16 0 0136.305-14.669l246.04 34.579z"
        opacity="0.19"
        stroke={`url(#${id}f)`}
        strokeOpacity="0.8"
        strokeWidth="5"
      />
      <path
        d="M239.732-131.82a37.096 37.096 0 0130.009 21.806l95.739 215.031a37.094 37.094 0 01-3.877 36.891L223.249 332.335a37.095 37.095 0 01-33.888 15.089L-44.731 322.82a37.098 37.098 0 01-30.01-21.806l-95.738-215.031a37.095 37.095 0 013.877-36.891l138.353-190.427a37.096 37.096 0 0133.89-15.089l234.091 24.604z"
        opacity="0.23"
        stroke={`url(#${id}g)`}
        strokeOpacity="0.8"
        strokeWidth="5"
      />
      <path
        d="M224.256-123.748a35.037 35.037 0 0129.044 19.592L350.751 95.65a35.03 35.03 0 01-2.443 34.948L223.997 314.897a35.04 35.04 0 01-31.489 15.359l-221.763-15.508a35.036 35.036 0 01-29.044-19.592L-155.75 95.35a35.03 35.03 0 012.443-34.948l124.31-184.299a35.036 35.036 0 0131.49-15.358l221.763 15.507z"
        opacity="0.28"
        stroke={`url(#${id}h)`}
        strokeOpacity="0.8"
        strokeWidth="5"
      />
      <path
        d="M209.525-114.889a32.974 32.974 0 0127.962 17.475l98.227 184.737a32.972 32.972 0 01-1.15 32.952L223.69 297.71a32.975 32.975 0 01-29.114 15.481l-209.1-7.302a32.975 32.975 0 01-27.963-17.475l-98.226-184.737a32.972 32.972 0 011.15-32.953L-28.689-106.71A32.975 32.975 0 01.425-122.191l209.1 7.302z"
        opacity="0.32"
        stroke={`url(#${id}i)`}
        strokeOpacity="0.8"
        strokeWidth="5"
      />
      <path
        d="M195.576-105.285a30.913 30.913 0 0126.77 15.458l98.076 169.872a30.912 30.912 0 010 30.912l-98.075 169.871a30.914 30.914 0 01-26.772 15.457H-.575a30.914 30.914 0 01-26.77-15.458l-98.076-169.871a30.91 30.91 0 01-.001-30.912l98.076-169.872A30.917 30.917 0 01-.575-105.285h196.151z"
        opacity="0.37"
        stroke={`url(#${id}j)`}
        strokeOpacity="0.8"
        strokeWidth="5"
      />
      <path
        d="M182.442-94.98a28.853 28.853 0 0125.474 13.547l97.015 155.256a28.852 28.852 0 011.007 28.833L219.99 264.301a28.857 28.857 0 01-24.468 15.29L12.559 285.98a28.855 28.855 0 01-25.474-13.547l-97.014-155.255a28.85 28.85 0 01-1.008-28.834l85.948-161.645A28.854 28.854 0 01-.52-88.59l182.963-6.389z"
        opacity="0.41"
        stroke={`url(#${id}k)`}
        strokeOpacity="0.8"
        strokeWidth="5"
      />
      <path
        d="M170.153-84.019a26.792 26.792 0 0124.079 11.746L289.294 68.66a26.79 26.79 0 011.869 26.725l-74.522 152.792a26.793 26.793 0 01-22.211 14.982L24.847 275.019a26.791 26.791 0 01-24.08-11.746l-95.06-140.934a26.788 26.788 0 01-1.87-26.725L-21.64-57.18A26.793 26.793 0 01.57-72.16l169.583-11.858z"
        opacity="0.46"
        stroke={`url(#${id}l)`}
        strokeOpacity="0.8"
        strokeWidth="5"
      />
      <path
        d="M158.741-72.45a24.73 24.73 0 0122.591 10.06l92.236 126.952a24.726 24.726 0 012.585 24.594L212.328 232.51a24.732 24.732 0 01-20.007 14.537L36.26 263.449a24.73 24.73 0 01-22.592-10.06l-92.236-126.951a24.728 24.728 0 01-2.585-24.594L-17.328-41.51A24.732 24.732 0 012.68-56.047L158.74-72.449z"
        opacity="0.5"
        stroke={`url(#${id}m)`}
        strokeOpacity="0.8"
        strokeWidth="5"
      />
      <path
        d="M148.23-60.319a22.671 22.671 0 0121.019 8.493l88.559 113.35a22.669 22.669 0 013.155 22.449l-53.885 133.37a22.673 22.673 0 01-17.864 13.957L46.77 251.319a22.672 22.672 0 01-21.018-8.493l-88.56-113.351a22.667 22.667 0 01-3.154-22.448l53.885-133.37A22.671 22.671 0 015.785-40.3L148.23-60.319z"
        opacity="0.55"
        stroke={`url(#${id}n)`}
        strokeOpacity="0.8"
        strokeWidth="5"
      />
      <path
        d="M138.647-47.677a20.608 20.608 0 0119.365 7.05l84.056 100.173a20.607 20.607 0 013.579 20.295l-44.725 122.881a20.608 20.608 0 01-15.787 13.247L56.354 238.677a20.608 20.608 0 01-19.365-7.05l-84.056-100.173a20.608 20.608 0 01-3.579-20.295L-5.92-11.721A20.61 20.61 0 019.866-24.97l128.781-22.708z"
        opacity="0.59"
        stroke={`url(#${id}o)`}
        strokeOpacity="0.8"
        strokeWidth="5"
      />
      <path
        d="M130.013-34.573a18.548 18.548 0 0117.639 5.733l78.751 87.46a18.546 18.546 0 013.856 18.142l-36.368 111.931a18.55 18.55 0 01-13.784 12.411L64.988 225.573a18.55 18.55 0 01-17.64-5.732l-78.75-87.461a18.547 18.547 0 01-3.856-18.142L1.11 2.308a18.55 18.55 0 0113.784-12.412l115.119-24.469z"
        opacity="0.64"
        stroke={`url(#${id}p)`}
        strokeOpacity="0.8"
        strokeWidth="5"
      />
      <path
        d="M122.347-21.059a16.487 16.487 0 0115.848 4.546l72.671 75.252a16.487 16.487 0 013.989 15.997l-28.836 100.561a16.486 16.486 0 01-11.859 11.453L72.653 212.058a16.484 16.484 0 01-15.848-4.545l-72.67-75.252a16.486 16.486 0 01-3.99-15.997L8.982 15.703A16.488 16.488 0 0120.841 4.25L122.347-21.06z"
        opacity="0.68"
        stroke={`url(#${id}q)`}
        strokeOpacity="0.8"
        strokeWidth="5"
      />
      <path
        d="M115.669-7.185a14.426 14.426 0 0113.997 3.49l65.846 63.587a14.426 14.426 0 013.977 13.867l-22.145 88.818a14.427 14.427 0 01-10.021 10.377l-87.991 25.231a14.425 14.425 0 01-13.998-3.49L-.512 131.108a14.425 14.425 0 01-3.976-13.867l22.144-88.818c1.247-5 5.067-8.956 10.022-10.377l87.991-25.231z"
        opacity="0.73"
        stroke={`url(#${id}r)`}
        strokeOpacity="0.8"
        strokeWidth="5"
      />
      <path
        d="M109.992 6.994a12.366 12.366 0 0112.095 2.572l58.307 52.5a12.363 12.363 0 013.821 11.76l-16.312 76.745a12.367 12.367 0 01-8.274 9.189l-74.62 24.246a12.363 12.363 0 01-12.095-2.572l-58.308-52.5a12.363 12.363 0 01-3.82-11.759l16.312-76.746a12.366 12.366 0 018.274-9.19l74.62-24.245z"
        opacity="0.77"
        stroke={`url(#${id}s)`}
        strokeOpacity="0.8"
        strokeWidth="5"
      />
      <path
        d="M105.33 21.427a10.304 10.304 0 0110.147 1.79l50.087 42.027a10.302 10.302 0 013.524 9.683l-11.353 64.39a10.306 10.306 0 01-6.624 7.894l-61.44 22.362a10.303 10.303 0 01-10.148-1.79l-50.087-42.027a10.305 10.305 0 01-3.524-9.683l11.354-64.39a10.305 10.305 0 016.623-7.894l61.441-22.362z"
        opacity="0.82"
        stroke={`url(#${id}t)`}
        strokeOpacity="0.8"
        strokeWidth="5"
      />
      <path
        d="M101.692 36.059a8.243 8.243 0 018.163 1.148l41.218 32.203a8.245 8.245 0 013.089 7.643l-7.28 51.798a8.247 8.247 0 01-5.075 6.496l-48.498 19.594a8.242 8.242 0 01-8.164-1.148L43.927 121.59a8.243 8.243 0 01-3.088-7.643l7.28-51.798a8.244 8.244 0 015.075-6.496l48.498-19.594z"
        opacity="0.86"
        stroke={`url(#${id}u)`}
        strokeOpacity="0.8"
        strokeWidth="5"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}b`}
          x1="17.079"
          x2="758.916"
          y1="641.072"
          y2="95.563"
        >
          <stop stopColor="#DCFFFF" />
          <stop offset="0.935" stopColor="#ADDCEC" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}c`}
          x1="328.84"
          x2="-133.839"
          y1="-144.059"
          y2="335.059"
        >
          <stop stopColor="#94D1EA" />
          <stop offset="1" stopColor="#FA8484" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}d`}
          x1="310.209"
          x2="-115.209"
          y1="-140.737"
          y2="331.737"
        >
          <stop stopColor="#94D1EA" />
          <stop offset="1" stopColor="#FA8484" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}e`}
          x1="292.105"
          x2="-97.104"
          y1="-136.421"
          y2="327.421"
        >
          <stop stopColor="#94D1EA" />
          <stop offset="1" stopColor="#FA8484" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}f`}
          x1="274.572"
          x2="-79.572"
          y1="-131.142"
          y2="322.143"
        >
          <stop stopColor="#94D1EA" />
          <stop offset="1" stopColor="#FA8484" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}g`}
          x1="257.658"
          x2="-62.657"
          y1="-124.937"
          y2="315.937"
        >
          <stop stopColor="#94D1EA" />
          <stop offset="1" stopColor="#FA8484" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}h`}
          x1="241.402"
          x2="-46.401"
          y1="-117.843"
          y2="308.843"
        >
          <stop stopColor="#94D1EA" />
          <stop offset="1" stopColor="#FA8484" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}i`}
          x1="225.847"
          x2="-30.846"
          y1="-109.898"
          y2="300.898"
        >
          <stop stopColor="#94D1EA" />
          <stop offset="1" stopColor="#FA8484" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}j`}
          x1="211.032"
          x2="-16.031"
          y1="-101.142"
          y2="292.143"
        >
          <stop stopColor="#94D1EA" />
          <stop offset="1" stopColor="#FA8484" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}k`}
          x1="196.994"
          x2="-1.992"
          y1="-91.619"
          y2="282.619"
        >
          <stop stopColor="#94D1EA" />
          <stop offset="1" stopColor="#FA8484" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}l`}
          x1="183.766"
          x2="11.234"
          y1="-81.372"
          y2="272.372"
        >
          <stop stopColor="#94D1EA" />
          <stop offset="1" stopColor="#FA8484" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}m`}
          x1="171.384"
          x2="23.616"
          y1="-70.446"
          y2="261.446"
        >
          <stop stopColor="#94D1EA" />
          <stop offset="1" stopColor="#FA8484" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}n`}
          x1="159.877"
          x2="35.123"
          y1="-58.888"
          y2="249.888"
        >
          <stop stopColor="#94D1EA" />
          <stop offset="1" stopColor="#FA8484" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}o`}
          x1="149.274"
          x2="45.727"
          y1="-46.746"
          y2="237.746"
        >
          <stop stopColor="#94D1EA" />
          <stop offset="1" stopColor="#FA8484" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}p`}
          x1="139.6"
          x2="55.401"
          y1="-34.07"
          y2="225.07"
        >
          <stop stopColor="#94D1EA" />
          <stop offset="1" stopColor="#FA8484" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}q`}
          x1="130.88"
          x2="64.121"
          y1="-20.909"
          y2="211.909"
        >
          <stop stopColor="#94D1EA" />
          <stop offset="1" stopColor="#FA8484" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}r`}
          x1="123.135"
          x2="71.865"
          y1="-7.315"
          y2="198.315"
        >
          <stop stopColor="#94D1EA" />
          <stop offset="1" stopColor="#FA8484" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}s`}
          x1="116.384"
          x2="78.617"
          y1="6.659"
          y2="184.34"
        >
          <stop stopColor="#94D1EA" />
          <stop offset="1" stopColor="#FA8484" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}t`}
          x1="110.643"
          x2="84.357"
          y1="20.962"
          y2="170.038"
        >
          <stop stopColor="#94D1EA" />
          <stop offset="1" stopColor="#FA8484" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}u`}
          x1="105.927"
          x2="89.073"
          y1="35.539"
          y2="155.461"
        >
          <stop stopColor="#94D1EA" />
          <stop offset="1" stopColor="#FA8484" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function CheckmarkIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-2 w-2.5 text-white", className)}
      viewBox="0 0 10 8"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M1.201 3.943c-.634-.709-1.65.37-.983 1.046.824.91 1.649 1.855 2.505 2.733.38.37.666.37 1.015 0L9.795 1.31C10.43.603 9.447-.477 8.781.231L3.262 6.102l-2.061-2.16z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
